module.exports = __webpack_public_path__ + "img/servo-oil-schematic-light.6cfac332.png";